import { faTrashCan } from "@fortawesome/pro-solid-svg-icons";
import type { BatchAction } from "@components/CatalogIndex";

export interface TextBlockBatchActionHandlers {
  onDelete: () => void;
}

export const buildTextBlockBatchActions = (
  _selectedCount: number,
  handlers: TextBlockBatchActionHandlers
): BatchAction[] => [
  {
    icon: faTrashCan,
    label: "Delete",
    onClick: handlers.onDelete,
    variant: "danger",
  },
];
